var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_741_2990",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 28,
    width: 8,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28.7295H18V32.2067H10V28.7295Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_741_2990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.994 32.207C15.8182 32.207 17.3697 31.0423 17.9462 29.4162C18.0624 29.0886 17.8241 28.7441 17.4763 28.7441H10.5113C10.1642 28.7441 9.92523 29.0886 10.0414 29.4162C10.6179 31.0423 12.1693 32.207 13.994 32.207Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_741_2990",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.929688H28V27.8297H0V0.929688Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_741_2990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7316 25.3577L24.014 24.1186C23.244 22.7886 22.8385 21.2793 22.8385 19.7427V16.8121C22.8385 12.5914 19.8768 9.06414 15.9181 8.18825V7.9173C15.9181 6.85845 15.0594 6 14 6C12.9407 6 12.082 6.85845 12.082 7.9173V8.18825C8.12324 9.06414 5.16129 12.5914 5.16129 16.8121V19.7427C5.16129 21.2793 4.756 22.7886 3.98578 24.1186L3.26842 25.3577C2.57622 26.3727 3.30306 27.7476 4.53191 27.7476H23.4681C24.6967 27.7476 25.4238 26.3727 24.7316 25.3577Z",
    fill: "#FFFBF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.b2a4547801650af72008f4ec65fee312.svg";
export { ForwardRef as ReactComponent };